<template>
  <v-app>
    <Authentication
      :register="null"
      :resetPassword="null"
      :cancel="'Cancel'"
      :success="true"
      :operationField="'appChangePassword'"
      :transactionField="'changePasswordTran'"
      :registerField="null"
      :resetPasswordField="null"
      :maxWidth="'500'"
      :inputUserName="true"
      :method="'post'"
      @transaction-process="transactionProcess"
      @close-dialog="closeDialog"
    />
  </v-app>
</template>

<script>
import { environment } from "./../../../environment/environment.js";
import Authentication from './Authentication';
export default {
  name: "ChangePassword",
  props: [],
  data() {
    return {
      environment: environment,
      changePasswordSuccess: false,
    };
  },
  components: {
    Authentication
  },
  methods: {
    transactionProcess(data) {
      this.changePasswordSuccess = data.success;
    },

    closeDialog(data) {
      if (this.changePasswordSuccess) {
        this.goToLogin(data.applicationName);
      }
    },

  },
  created() {
  },
};
</script>

<style>
</style>